import { useState } from 'react';
import { type AuthState, useAuth } from '../auth/AuthProvider.js';
import { signInErrorMessage } from '../auth/session.js';
import { EmailDeliveryHint } from '../components/EmailDeliveryHint.js';

/** Signed in, but K-Management does not let the account in: not registered, e-mail to verify, wrong method. */
export function AccessRefusedPage({
  refusal,
}: {
  refusal: Extract<AuthState, { status: 'refused' }>;
}) {
  const { signOut } = useAuth();

  return (
    <main className="centered">
      <section className="card sign-in stack">
        {refusal.code === 'email-not-verified' ? (
          <VerifyEmail email={refusal.email} />
        ) : (
          <>
            <h1>Accesso non autorizzato</h1>
            <p>{refusal.message}</p>
            {refusal.code === 'not-registered' ? (
              <p className="muted">
                Chiedi all’amministratore di abilitare <strong>{refusal.email}</strong>, oppure
                accedi con un altro account.
              </p>
            ) : (
              <p className="muted">Esci e usa «Accedi con Microsoft 365».</p>
            )}
          </>
        )}
        <button type="button" className="wide" onClick={() => void signOut()}>
          Esci e cambia account
        </button>
      </section>
    </main>
  );
}

function VerifyEmail({ email }: { email: string }) {
  const { session, recheck } = useAuth();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  const run = async (action: () => Promise<void>, done?: string) => {
    setBusy(true);
    setMessage(null);
    try {
      await action();
      if (done) setMessage(done);
    } catch (failure) {
      setMessage(signInErrorMessage(failure));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <h1>Conferma la tua e-mail</h1>
      <p>
        Ti abbiamo inviato un’e-mail a <strong>{email}</strong>. Apri il link che contiene, poi
        torna qui e premi «Ho confermato».
      </p>
      <EmailDeliveryHint />
      <button
        type="button"
        className="primary wide"
        disabled={busy}
        onClick={() => void run(recheck)}
      >
        Ho confermato
      </button>
      <button
        type="button"
        className="link"
        disabled={busy}
        onClick={() =>
          void run(
            () => session!.resendVerification(),
            'E-mail inviata di nuovo: controlla anche la posta indesiderata.',
          )
        }
      >
        Invia di nuovo l’e-mail
      </button>
      {message && <p className="muted">{message}</p>}
    </>
  );
}
